import React from "react"
import { motion } from "framer-motion"

interface CTASectionProps {
  clinicImage: string
}

export const CTASection: React.FC<CTASectionProps> = ({ clinicImage }) => {
  return (
    <section className="py-32 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 relative overflow-hidden">
      <motion.div
        className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"
        animate={{
          x: [0, 100, 0],
          y: [0, -100, 0],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <motion.div
        className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"
        animate={{
          x: [0, -100, 0],
          y: [0, 100, 0],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <motion.img
        src={clinicImage}
        alt="clinic-center"
        className="absolute w-48 md:w-64 rounded-xl opacity-10 top-1/2 left-1/2"
        style={{ transform: "translate(-50%, -50%)" }}
        animate={{
          scale: [1, 1.1, 1],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <div className="container mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.h2
          className="text-4xl md:text-6xl font-bold text-white mb-8"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          당신의 한의원을 변화시킬 준비가 되셨나요?
        </motion.h2>

        <div className="relative inline-block">
          <motion.button
            className="px-12 py-6 bg-white text-purple-600 rounded-full font-bold text-xl shadow-2xl hover:shadow-3xl transition-all"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            whileHover={{ scale: 1.1, y: -5 }}
            whileTap={{ scale: 0.95 }}
            onClick={() =>
              window.open("https://www.sigmachart.co.kr/submit-trial", "_blank")
            }
          >
            체험판 설치 신청하기
          </motion.button>
        </div>
      </div>
    </section>
  )
}
